import { urls } from '@api/urls.ts';
import axiosInstance from '@api/axios.ts';
import { UserTourGuide } from '@app/types/user';

export const updateTourGuide = async (): Promise<void> => {
  const response = await axiosInstance.post(urls.userTourGuide.base);

  return response.data;
};

export const getTourGuide = async (): Promise<UserTourGuide> => {
  const response = await axiosInstance.get(urls.userTourGuide.base);
  return response.data;
};

// Secondary tour for Demand Letter creation
export const updateSecondaryTourGuide = async (): Promise<void> => {
  const response = await axiosInstance.post(urls.userTourGuide.secondary);

  return response.data;
};

export const getSecondaryTourGuide = async (): Promise<{
  has_seen_secondary_tour: boolean;
}> => {
  const response = await axiosInstance.get(urls.userTourGuide.secondary);
  return response.data;
};
